import { SET_USER_TOKEN, CLEAR_USER_TOKEN, SET_USER_INFO, CLEAR_USER_INFO, SET_ORDERS } from '../types';
import router, { routes } from '@/router';
import { services } from '@/service';
import qs from 'qs';

export default {
  state: {
    token: '',
    userInfo: null,
    orders: [],
    courseLockSize: 150000
  },
  getters: {
    isAdmin: state => (state.userInfo && state.userInfo.admin) || false,
    isLogin: state => !!state.token,
    token: state => state.token,
    userInfo: state => state.userInfo,
    orders: state => state.orders
  },
  actions: {
    setToken({ commit }, token) {
      commit(SET_USER_TOKEN, token);
    },
    async initUserAuthriozation({ commit, dispatch, getters }) {
      const token = localStorage.getItem('token');
      const userInfoString = localStorage.getItem('userInfo');

      const { href } = window.location;
      const query = qs.parse(href.split('?')[1] || '');
      const exportToken = query.export_token;
      if (exportToken) {
        commit(SET_USER_TOKEN, decodeURIComponent(exportToken));
        commit(SET_USER_INFO, {});
      } else if (token) {
        commit(SET_USER_TOKEN, token);
        !!userInfoString && commit(SET_USER_INFO, JSON.parse(userInfoString));
      }

      if (getters.isLogin) {
        const promises = [];
        if (!exportToken && !userInfoString) {
          promises.push(dispatch('getUserInfo'));
        }
        promises.push(dispatch('getOrders'));
        try {
          await Promise.all(promises);
        } catch (err) {
          dispatch('logout', { replaceToLogin: false, sendEvent: false });
        }
      }
    },
    async logout({ commit }, params = {}) {
      const { replaceToLogin = true, sendEvent = true } = params;
      const token = localStorage.getItem('token');
      if (token && sendEvent) {
        await services.authriozation.setLogout();
      }
      commit(CLEAR_USER_TOKEN);
      commit(CLEAR_USER_INFO);
      commit(SET_ORDERS, []);
      const curIsLoginPath = location.hash.indexOf('#/wechat/login') === 0;
      if (replaceToLogin && !curIsLoginPath) {
        const [curPath, ...queryStrArr] = location.hash.split('?');
        const routeItem = routes.find(o => o.path === curPath.slice(1));
        if (routeItem && !sendEvent) {
          router.replace({
            name: 'wechatLogin',
            query: { redirect_name: routeItem.name, redirect_query: queryStrArr.join('?') }
          });
        } else {
          router.replace({ name: 'wechatLogin' });
        }
      }
    },
    async login({ commit }, model) {
      const result = await services.authriozation.login(model);
      if (!result.token) {
        throw new Error('wechatCode错误，登录失败，请刷新页面后再试');
      }
      commit(SET_USER_TOKEN, result.token);
    },
    async valid({ commit }, model) {
      const result = await services.authriozation.setValid(model);
      commit(SET_USER_TOKEN, result.token);
    },
    async getUserInfo({ commit }) {
      const userInfo = await services.authriozation.getUserInfo();
      commit(SET_USER_INFO, userInfo);
    },
    async getOrders({ commit }) {
      const result = await services.authriozation.getOrders({
        isAvailableOrder: true,
        getOrgOrder: true
      });
      commit(SET_ORDERS, result.data);
    }
  },
  mutations: {
    [SET_USER_TOKEN](state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    [CLEAR_USER_TOKEN](state) {
      state.token = '';
      localStorage.removeItem('token');
    },
    [SET_USER_INFO](state, userInfo) {
      state.userInfo = userInfo;
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    [CLEAR_USER_INFO](state) {
      state.userInfo = null;
      localStorage.removeItem('userInfo');
    },
    [SET_ORDERS](state, orders) {
      state.orders = orders;
    }
  }
};
